import { useEffect, useState } from "react";
import { DateTime } from "luxon";

const zone = "America/Los_Angeles";

export function trialDates(subscription, now = DateTime.now()) {
  const expiry = Number.isFinite(subscription?.nextBillingDate)
    ? DateTime.fromSeconds(subscription.nextBillingDate, { zone })
    : DateTime.invalid("Missing trial expiry");
  const localNow = now.setZone(zone);
  const expired = !expiry.isValid || localNow >= expiry;
  // endedOn is an exclusive instant, not a duration to reconstruct from plan metadata.
  const lastAccess = expiry.minus({ milliseconds: 1 });
  return {
    expired,
    lastDay: expiry.isValid ? lastAccess.toFormat("MMMM d, yyyy") : "",
    daysLeft: expired ? 0 : Math.round(lastAccess.startOf("day").diff(localNow.startOf("day"), "days").days) + 1,
  };
}

// Refresh every trial at Pacific midnight and the exact expiry, even on an open page.
export function useTrialNow(subscription) {
  const [now, setNow] = useState(() => DateTime.now());
  const expirySeconds = subscription?.nextBillingDate;
  const isTrial = subscription?.internalName === "PFL_TRIAL";
  useEffect(() => {
    if (!isTrial || !Number.isFinite(expirySeconds) || !DateTime.fromSeconds(expirySeconds).isValid) return undefined;
    let timer;
    function schedule() {
      const current = DateTime.now();
      setNow(current);
      const expiry = expirySeconds * 1000;
      if (current.toMillis() >= expiry) return;
      const midnight = current.setZone(zone).plus({ days: 1 }).startOf("day").toMillis();
      timer = setTimeout(schedule, Math.max(1, Math.min(midnight, expiry) - current.toMillis()));
    }
    schedule();
    return () => clearTimeout(timer);
  }, [isTrial, expirySeconds]);
  return now;
}
